var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-overlay',[_c('rkm-layout-body',{attrs:{"title":"Gerenciamento por médico"},scopedSlots:_vm._u([{key:"actions",fn:function(){return [_c('rkm-button',{attrs:{"color":"danger"},on:{"click":_vm.exit}},[_vm._v(" Sair ")])]},proxy:true}])},[_c('rkm-layout-content',[_c('Form',{ref:"Form",attrs:{"id":_vm.id},on:{"saved":_vm.saved}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }